import React, { useEffect, useState } from 'react';
import "../css/Auth.css"
import Cookies from 'js-cookie';
import { Navigate, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { MdOutlineEmail } from "react-icons/md";
import { loginActions } from '../actions/authAction';
import { useDispatch } from 'react-redux';
import * as imagesdata from '../imagesdata'
import { getLoggedInUser } from '../axios';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [windowHeight, setWindowHeight] = useState(0);
  const [windowWidth, setWindowWidth] = useState(0);
  const [showPassword, setShowPassword] = useState(false);

  const [isButtonDisable, setIsButtobDisable] = useState(false);

  function setEmailHandler(evt) {
    setFormData({ ...formData, email: evt.target.value });
  }

  function setPasswordHandler(evt) {
    setFormData({ ...formData, password: evt.target.value });
  }

  const doLogin = (e) => {
    e.preventDefault();
    setIsButtobDisable(true)
    dispatch(loginActions(formData))
      .then(() => {
        setIsButtobDisable(false)
      })
  }

  const animations = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight;
      const width = window.innerWidth;
      if (window.innerHeight < 620) {
        setWindowHeight(620)
      }
      else {
        setWindowHeight(height)
      }
      setWindowWidth(width)
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const togglePW = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await getLoggedInUser();
        setUser(response.data)

      } catch (error) {
        setUser(null)
      }
    };
    checkAuth();
  }, []);


  if (user) {
    return window.location.href = '/';
  } else {
    return (
      <motion.div
        className="py-3"
        variants={animations}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 1 }}
      >
        <div className="wrapper" style={{ backgroundColor: "white", maxHeight: windowHeight - 1 }}>
          <form onSubmit={doLogin} className='auth-form'>
            <div className="login-options">
              <div className="login-image-container" style={{
                height: windowHeight < windowWidth - 500 ? windowWidth - 500 : windowHeight - 1,
                width: windowWidth,
                overflowY: 'hidden'
              }}>
                <img className="login-image" src={imagesdata.Auth} alt="Login" />
              </div>
              <div className="login-form" style={{ height: windowHeight }}>
                <a href='/'><img src={imagesdata.TersLogo} alt="Logo" style={{ height: "69px", width: "200px", marginTop: "50px" }} /></a>
                <h2><span>Giriş Yap</span></h2>
                <div className="form-wrapper" >
                  <label htmlFor="email">E-posta</label>
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={setEmailHandler}
                  />
                </div>
                <div className="form-wrapper" >
                  <label htmlFor="password">Şifre</label>
                  <div className="input-eye-wrapper">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      className="form-control"
                      name="password"
                      value={formData.password}
                      onChange={setPasswordHandler}
                    />
                    <div
                      className={`eye ${showPassword ? '' : 'slash'}`}
                      onClick={togglePW}
                    >
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <div className='forgot-password-container'> <a className='forgot-password' href='/sifremi-unuttum'>Şifremi Unuttum</a></div>
                </div>
                <div style={{ width: "100%" }}>
                  <button className="auth-button button-submit" disabled={isButtonDisable} type="submit"> <span> Giriş Yap </span></button>
                </div>
                <div>
                  <div className='login-register-button-container'>Henüz Hesap Oluşturmadın mı?
                    <a className='login-register-button' href='/kayit-ol'>Şimdi Kaydol</a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </motion.div>
    );
  }
};

export default Login;
